import { render, staticRenderFns } from "./WxLoginModel.vue?vue&type=template&id=1619c6ee&scoped=true"
import script from "./WxLoginModel.vue?vue&type=script&lang=js"
export * from "./WxLoginModel.vue?vue&type=script&lang=js"
import style1 from "./WxLoginModel.vue?vue&type=style&index=1&id=1619c6ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1619c6ee",
  null
  
)

export default component.exports